export enum Manufacturing {
  FDA = 'FDA Manufacturing License',
  EXPORT = 'Export'
}
